export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/exam/createAgent',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allAgents']       
    })
